module.exports = __webpack_public_path__ + "banner.png?983c4c537cc7d838fe4ba55a177067d5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = 648
// module chunks = 0